import { styled } from "@mui/material/styles";

const ScrollableContainer = styled("div")({
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "10px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
});

const Scrollbar = ({ isBorder, children, ...props }: any) => {
  return (
    <ScrollableContainer
      {...props}
      sx={{ border: isBorder ? "1px solid #F1F1F1" : "", borderRadius: "10px" }}
    >
      {children}
    </ScrollableContainer>
  );
};

export default Scrollbar;
